<template id="1">
  <v-container class="pagei">

  <div v-if="loading" class="loading">
    <img v-if="gif" :src="gif" alt="Loading..." width="100px"/>
  </div>

  <v-row v-if="response" align="center" justify="center" class="res">
    <br>


    <div class="dbtns">
      <div class="select_">
        <span 
          class="choice" 
          :class="{ activech: activeChoice === 'CSV' }" 
          @click="setActiveChoice('CSV')">
          CSV
        </span>
        <span 
          class="choice" 
          :class="{ activech: activeChoice === 'JSON' }" 
          @click="setActiveChoice('JSON')">
          JSON
        </span>
      </div>

      <span class="dl_btn" @click="downloadSearch">Download the search</span>
    </div>

    <br>
    
    <v-col v-for="(module_, i) in response" :key="i" cols="12" class="my-2">

        <v-card
          class="mx-auto data-card"
          max-width="100%"
          width="1000px"
          :title="module_.module_name"
          :prepend-avatar="module_.module_logo"
        >
        <v-divider></v-divider>

        <iframe 
            v-if="module_.lat && module_.long"
            style="filter: grayscale(100%) invert(92%) contrast(83%);"
            width="100%"
            height="380px"
            class="gmap_iframe" 
            frameborder="0" 
            scrolling="no" 
            marginheight="0" 
            marginwidth="0" 
            :src="'https://www.google.com/maps?q=' + module_.city + '&zoom=2&output=embed'">
          </iframe>

          <v-divider></v-divider>
          <v-card-item>

          <v-table fixed-header class="table1">

          <tbody>
            <tr
              v-for="key, value in removeModuleMetadata(module_)"
              :key="key"
            >
            
              <td class="key_style" v-if="value != 'profile_url'">{{ value}}</td>
              <td v-if="value != 'profile_url'" class="pre-wrap" ><b>{{ key }}</b></td>
            </tr>
          </tbody>
        </v-table>

          </v-card-item>


          <v-divider  v-if="module_.profile_url"></v-divider>
          <br v-if="module_.profile_url">
          <a target="_blank" :href="module_.profile_url" v-if="module_.profile_url" class="d-flex align-center justify-center btnopen">
          <v-icon left class="mr-2">mdi-open-in-new</v-icon>View Account
          </a>
          <br v-if="module_.profile_url">

        </v-card>
      </v-col>
    
    
  </v-row>


<div class="search-container" v-if="!response">

<v-card
  class="mx-auto pa-12 pb-8"
  elevation="8"
  width="650"
  id="transparent"
  v-if="!loading && !response"
>

<h1  style="text-align: center;">XSINT Lookup</h1>
<center>
  <p style="text-align: center;">Uncover valuable insights by searching for data on XSINT.</p>
  <br>

  <v-btn 
  v-for="(label, index) in ['EMAIL', 'PHONE', 'IP']" 
  :key="index" 
  :class="{ 'active-btn': tab === index + 1 }" 
  @click="tab = index + 1"
  class="tab-btn"
>
  {{ label }}
</v-btn>
</center>

<br><br>

  <div class="d-flex align-center justify-space-between">
    <v-text-field
      v-if="!userdata && tab == 1"
      placeholder="test@example.com"
      append-icon="mdi-magnify"
      hide-details="auto"
      outlined
      dense
      class="search-bar flex-grow-1"
      @keydown.enter="redirectToLogin"
      @click:append="redirectToLogin"
    ></v-text-field>
    <v-text-field
      v-else-if="userdata  && userdata.research >= 1 && tab == 1"
      placeholder="test@example.com"
      v-model="searchQuery"
      append-icon="mdi-magnify"
      hide-details="auto"
      outlined
      dense
      class="search-bar flex-grow-1"
      @keydown.enter="emailsearch"
      @click:append="emailsearch"
    ></v-text-field>
    <v-text-field
      v-else-if="userdata  && userdata.research < 1 && tab == 1"
      placeholder="test@example.com"
      v-model="searchQuery"
      append-icon="mdi-magnify"
      hide-details="auto"
      outlined
      dense
      class="search-bar flex-grow-1"
      @keydown.enter="redirectToProducts"
      @click:append="redirectToProducts"
    ></v-text-field>


    <v-text-field
      v-if="!userdata && tab == 2"
      placeholder="+33333333333"
      append-icon="mdi-magnify"
      hide-details="auto"
      outlined
      dense
      class="search-bar flex-grow-1"
      @keydown.enter="redirectToLogin"
      @click:append="redirectToLogin"
    ></v-text-field>
      <v-text-field
        v-else-if="userdata  && userdata.research >= 1 && tab == 2"
        placeholder="+33333333333"
        v-model="searchQuery"
        append-icon="mdi-magnify"
        hide-details="auto"
        outlined
        dense
        class="search-bar flex-grow-1"
        @keydown.enter="phonesearch"
        @click:append="phonesearch"
      ></v-text-field>
      <v-text-field
      v-else-if="userdata  && userdata.research < 1 && tab == 2"
      placeholder="+33333333333"
      v-model="searchQuery"
      append-icon="mdi-magnify"
      hide-details="auto"
      outlined
      dense
      class="search-bar flex-grow-1"
      @keydown.enter="redirectToProducts"
      @click:append="redirectToProducts"
    ></v-text-field>

    <v-text-field
      v-if="!userdata && tab == 3"
      placeholder="IP address"
      append-icon="mdi-magnify"
      hide-details="auto"
      outlined
      dense
      class="search-bar flex-grow-1"
      @keydown.enter="redirectToLogin"
      @click:append="redirectToLogin"
    ></v-text-field>
    <v-text-field
      v-else-if="userdata  && userdata.research >= 1 && tab == 3"
      placeholder="IP address"
      v-model="searchQuery"
      append-icon="mdi-magnify"
      hide-details="auto"
      outlined
      dense
      class="search-bar flex-grow-1"
      @keydown.enter="ipsearch"
      @click:append="ipsearch"
    ></v-text-field>
    <v-text-field
      v-else-if="userdata  && userdata.research < 1 && tab == 3"
      placeholder="IP address"
      v-model="searchQuery"
      append-icon="mdi-magnify"
      hide-details="auto"
      outlined
      dense
      class="search-bar flex-grow-1"
      @keydown.enter="redirectToProducts"
      @click:append="redirectToProducts"
    ></v-text-field>


  </div>

    <br>
    <center>
    <CaptchaWidget ref="altchaWidget" @captcha-verified="handleCaptchaVerified"></CaptchaWidget>
  </center>

</v-card>

  </div>
</v-container>
  <div v-if="!response" style="height: 27vh;"></div>
</template>
<script setup>
import { useHead } from '@vueuse/head';

useHead({
  title: 'Lookup | XSINT Intelligence',
  meta: [
    { name: 'description', content: 'Search for emails, ip addresses and phone numbers with XSINT\'s advanced lookup tool. Quickly find and verify email addresses from various sources.' },
    { name: 'keywords', content: 'email search, XSINT, XSINT lookup, email verification, OSINT phone search' },
    { name: 'robots', content: 'index, follow' },
    { name: 'author', content: 'XSINT Intelligence' },

    { property: 'og:title', content: 'Lookup | XSINT Intelligence' },
    { property: 'og:description', content: 'Search for emails with XSINT\'s advanced email search tool. Quickly find and verify email addresses from various sources.' },
    //{ property: 'og:image', content: 'https://www.xsint-intelligence.com/images/email-search-og-image.jpg' }, 
    { property: 'og:url', content: 'https://www.xsint-intelligence.com/lookup' },
    { property: 'og:type', content: 'website' },

    { name: 'twitter:title', content: 'Lookup | XSINT Intelligence' },
    { name: 'twitter:description', content: 'Search for emails, ip addresses and phone numbers with XSINT\'s advanced lookup tool. Quickly find and verify email addresses from various sources.' },
    //{ name: 'twitter:image', content: 'https://www.xsint-intelligence.com/images/email-search-twitter-image.jpg' },
   // { name: 'twitter:card', content: 'summary_large_image' }
  ]
});
</script>
<script>
import 'altcha';
import { mapGetters } from 'vuex';
import { useToast } from 'vue-toastification';
import CaptchaWidget from '@/components/CaptchaWidget.vue';
export default {
  data() {
    return {
      searchQuery: '',
      userdata: JSON.parse(localStorage.getItem('userdata')),
      loading: false,
      response: false,
      gif: false,
      tab: 1,
      activeChoice: 'CSV',
    };
  },
  computed: {
    ...mapGetters(['backend']),
  },

  components: {
    CaptchaWidget
  },
  methods: {
    setActiveChoice(choice) {
      this.activeChoice = choice;  // Met à jour le bouton actif
    },

    redirectToProducts() {
      window.open('/#pricing', '_blank');
    },
    redirectToLogin() {
      this.$router.push('/login');
    },
    downloadSearch() {
      if (!this.response || this.response.length === 0) return;

      if (this.activeChoice === 'CSV') {
        this.downloadCSV(this.response);
      } else if (this.activeChoice === 'JSON') {
        this.downloadJSON(this.response);
      }
    },

    downloadCSV(data) {
  const csvRows = [];
  
  // Ajouter l'en-tête du CSV
  csvRows.push('Module Name,Module Data');
  
  // Parcourir les modules pour extraire leur nom et leur contenu
  data.forEach((module_) => {
    const moduleName = module_.module_name; // Récupère le nom du module
    const moduleData = this.removeModuleMetadata(module_); // Récupère les données sans métadonnées
    
    // Sérialiser les données du module en format JSON
    const moduleDataJson = JSON.stringify(moduleData);
    
    // Échapper les guillemets dans les valeurs JSON pour éviter des problèmes dans le CSV
    const safeModuleName = `"${moduleName.replace(/"/g, '""')}"`;  // Remplacer les guillemets par des guillemets doublés
    const safeModuleDataJson = `"${moduleDataJson.replace(/"/g, '""')}"`; // Idem pour les données JSON
    
    // Ajouter une ligne avec le nom du module et les données sérialisées
    csvRows.push(`${safeModuleName},${safeModuleDataJson}`);
  });

  // Créer le contenu CSV
  const csvString = csvRows.join('\n');
  const blob = new Blob([csvString], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `XSINT_SEARCH_RESULTS_${new Date().toISOString()}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
},



    downloadJSON(data) {
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `XSINT_SEARCH_RESULTS_${new Date().toISOString()}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },

    handleCaptchaVerified(payload) { this.captcha_payload = payload },

    removeModuleMetadata(module_) {
      const moduleWithoutMetadata = Object.assign({}, module_);
      delete moduleWithoutMetadata.module_logo;
      delete moduleWithoutMetadata.index_name;
      delete moduleWithoutMetadata.module_name;

      return moduleWithoutMetadata;
    },
    async emailsearch() {
      const gifs = ["https://video-public.canva.com/VAEYapXPdjM/v/4257df9eec.gif"];
      const random = Math.floor(Math.random() * gifs.length);
      this.gif = gifs[random];

      this.loading = true;

      const email = this.searchQuery;
      const token = localStorage.getItem("Authorization");

      const toast = useToast();
      let response = null;

      try {
        response = await this.$axios.post(`${this.backend}/api/search/email`, { email: email, captcha_payload: this.captcha_payload}, {
          headers: {
            "Authorization": token,
          }
        });
        this.response = response.data;
      } catch (err) {
        console.error("Error searching email:", err);
        
        // Check if `err.response` is defined before accessing it
        if (err.response && err.response.data && err.response.data.error) {
          toast.error((err.response.data.error).toString());
        } else {
          // If no response or data, display a general error message
          toast.error("An unexpected error occurred. Please try again.");
        }
      }

      this.loading = false;
      this.captcha_payload = null;
    },

    async phonesearch() {
        const gifs = ["https://video-public.canva.com/VAEYapXPdjM/v/4257df9eec.gif"];
        const random = Math.floor(Math.random() * gifs.length);
        this.gif = gifs[random];
  
        this.loading = true;
  
        const phone = this.searchQuery;
        const token = localStorage.getItem("Authorization");
  
        const toast = useToast();
        let response = null;
        
        try {
          response = await this.$axios.post(`${this.backend}/api/search/phone`, { phone: phone, captcha_payload: this.captcha_payload}, {
            headers: {
              "Authorization": token,
            }
          });
          this.response = response.data;
        } catch (err) {
          console.error("Error searching phone:", err);
          toast.error((err.response.data.error).toString());
        }
  
        this.loading = false;
        this.captcha_payload = null
    },

    async ipsearch() {
      const gifs = ["https://video-public.canva.com/VAEYapXPdjM/v/4257df9eec.gif"];
      const random = Math.floor(Math.random() * gifs.length);
      this.gif = gifs[random];

      this.loading = true;

      const data = this.searchQuery;
      const token = localStorage.getItem("Authorization");

      const toast = useToast();
      let response = null;


      try {
        response = await this.$axios.post(`${this.backend}/api/search/ip`, { ip: data, captcha_payload: this.captcha_payload}, {
          headers: {
            "Authorization": token,
          }
        });
        this.response = response.data;
        
  
      } catch (err) {
        console.error("Error searching data:", err);
        toast.error((err.response.data.error).toString());
      }

      this.loading = false;
      
    },
    
  },

};
</script>

<style scoped>
.pagei{
  justify-content: center; 
  align-items: center; 
  align-items: center;
  height: 73vh; 
}
.tab-btn {
  margin-right: 20px;
  background-color: #1d1d1d;
  border-radius: 5px;
  color: white;
  font-weight: normal;
  padding: 10px 20px;
  text-transform: uppercase;
  cursor: pointer;
  border: none;
}

.tab-btn:hover {
  background-color: rgba(0, 102, 255, 0.76);
}

.active-btn {
  color: #ffffff;
  font-weight: bold;
  background-color: rgba(0, 102, 255, 0.76);
}


.res {
  margin-top: 25%;
}

@media only screen and (min-width: 600px) {
  h1{
            font-size: 65px;
            color: white;
            font-family: Inter, sans-serif;
  }

  .tab-btn {
    margin-right: 10px;
  }

  #tabs .v-tab {
    margin-right: 10px;
  }
  .res {
    margin-top: 7%;
  }
}


.loading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.search-container {
  display: flex;
  margin-top: 11%;
  align-items: center;
}

#transparent {
  background-color: transparent !important;
  box-shadow: none !important;
}


.styled-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.styled-list li {
  margin: 4px 0;
  padding: 8px;
  border-radius: 4px;
  color: #fff;
}

.text-p {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  color: #fff;
}

strong {
  font-weight: bold;
  color: #ffffff;
}

.formatted-object {
  font-family: 'Courier New', Courier, monospace;
  padding: 8px;
  border-radius: 4px;
  white-space: pre-wrap;
  color: #fff;
}

.pre-wrap {
  white-space: pre-wrap;
}

.dbtns {
  display: flex; /* Utiliser flexbox pour l'alignement */
  justify-content: center; /* Centrer les éléments horizontalement */
  align-items: center; /* Centrer les éléments verticalement */
  gap: 20px; /* Ajouter un espacement entre le groupe select et le bouton */
  padding: 20px;
}

.select_ {
  display: flex; /* Aligner les éléments de type CSV et JSON horizontalement */
  gap: 15px; /* Espacement entre CSV et JSON */
  background-color:rgba(29, 29, 29, 0.29); /* Fond doux */
  padding: 5px;
  border-radius: 8px; /* Coins arrondis */
}

.choice {
  padding: 8px 10px; /* Un peu de padding pour les éléments */
  color: white; 
  font-weight: bold; 
  border-radius: 5px; 
  cursor: pointer; 
  transition: background-color 0.3s ease;
}

.choice:hover {
  background-color:rgba(0, 123, 255, 0.22); /* Changer de couleur au survol */
  color: white; /* Texte blanc au survol */
}

.dl_btn {
  padding: 10px 20px; /* Padding autour du texte */
  background-color: #007BFF; /* Couleur bleue du bouton */
  color: white; /* Texte en blanc */
  font-weight: bold;
  border-radius: 8px; /* Coins arrondis */
  cursor: pointer; /* Curseur pointer */
  transition: background-color 0.3s ease, transform 0.2s ease; /* Effet d'animation */
  text-transform: uppercase; /* Mettre le texte en majuscule */
}

.dl_btn:hover {
  background-color:rgb(31, 31, 31); /* Bleu plus foncé au survol */
  transform: scale(1.05); /* Agrandissement léger du bouton au survol */
}

.activech{
  color:rgb(126, 126, 126)
}



.data-card {
  background-color: rgba(95, 95, 95, 0.18) !important; 

}

.table1{
  background-color: rgba(95, 95, 95, 0) !important; 
}

.key_style{
  color: rgb(206, 206, 206) 
}


.valut_style{
  color: rgb(255, 255, 255) 
}

.btnopen{
  background-color: rgba(95, 95, 95, 0) !important; 
  margin-left: 10px;
}




</style>
